import React from "react";
import { SidebarFooter } from "@/components/ui/Sidebar";
import { Button } from "@/components/ui/Button";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { LoaderCircle } from "lucide-react";

interface FilterFooterProps {
  onApply?: () => void;
  onClear?: () => void;
  loading?: boolean;
  applyDisabled?: boolean;
  clearDisabled?: boolean;
}

export const Footer = ({
  onApply,
  onClear,
  loading,
  applyDisabled,
  clearDisabled,
}: FilterFooterProps) => {
  const { t } = useTranslation();

  const clearClassName = clearDisabled
    ? "text-button-bright/60"
    : "cursor-pointer";
  return (
    <SidebarFooter className="flex flex-row items-center px-4 pt-4 pb-21">
      <div className="flex-grow font-medium text-button-bright">
        <button
          className={clearClassName}
          aria-disabled={clearDisabled}
          onClick={() => {
            if (!clearDisabled && onClear) onClear();
          }}
        >
          {t("filters.clear")}
        </button>
      </div>
      <Button
        className={cn("font-regular flex-grow text-secondary")}
        onClick={() => {
          if (!applyDisabled && !loading && onApply) onApply();
        }}
        disabled={applyDisabled || loading}
      >
        {loading && (
          <>
            <span className="sr-only">{t("global.loading")}</span>
            <LoaderCircle className="animate-spin" />
          </>
        )}
        {t("filters.apply")}
      </Button>
    </SidebarFooter>
  );
};
